import { useCallback } from 'react';
import { generatePath, useNavigate } from 'react-router';
import {
  setConfirmCandidateSource,
  type TConfirmCandidateSource,
} from '~/domain/ConfirmCandidateSource';
import { routes } from '~/routes';

interface INavigateToConfirmCandidateOptions {
  /** Shift the office is confirming for. Scopes the recorded source. */
  shiftId: string;
  candidateId: string;
  /** What drove the click, reported later on `confirm_clicked` (GOTU-4906). */
  source: TConfirmCandidateSource;
}

/**
 * Navigates to the Confirm Candidate screen and records what drove the click in
 * the same call (GOTU-4906).
 *
 * The two belong together: the source is read back at confirm time, so a
 * navigation that forgot to record one reports no attribution at all. Keeping
 * them in one function stops the pair drifting apart as call sites are edited.
 */
export const useNavigateToConfirmCandidate = () => {
  const navigate = useNavigate();

  return useCallback(
    ({ shiftId, candidateId, source }: INavigateToConfirmCandidateOptions) => {
      setConfirmCandidateSource({ source, shiftId });
      navigate(generatePath(routes.confirmCandidate, { jobId: shiftId, candidateId }));
    },
    [navigate],
  );
};
